/** System announcement acknowledgement-popup timing. */

export const POPUP_DELAY_MS = 2000
